import React from "react";

/** Logo mark with a WebP source and a resized PNG fallback. */
const BrandImage = ({ src, alt, className, ...rest }) => {
  const webp = src.replace(/\.png(?=[?#]|$)/i, ".webp");
  return (
    <picture>
      <source srcSet={webp} type="image/webp" />
      <img src={src} alt={alt} className={className} decoding="async" {...rest} />
    </picture>
  );
};

export default BrandImage;
